<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-select :items="licenses" label="License" v-model="license" @change="refresh" dense hide-details outlined class="ml-6"/>
        </v-col>
        <v-col cols="5" align-self="center" offset="1">
          <reports-excise-file-button :month="month"/>
        </v-col>
        <v-col align-self="center">
          <v-btn outlined small @click="rates()">Excise rates</v-btn>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Excise spirits return',report(true))"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report(false)"/>
    </v-card>

    <component :is="exciseRates" v-model="showExciseRates"/>

    <v-dialog v-model="showDetails" width="80%">
      <v-card>
        <v-card-title>
          {{title}}
          <v-spacer/>
          <v-icon @click="showDetails=false">mdi-close</v-icon>
        </v-card-title>
        <v-data-table :items="activityReport" disable-pagination disable-filtering disable-sort
                      fixed-header calculate-widths hide-default-footer height="400" class="pa-4"
                      no-data-text="No activity in period"
                      :headers="[{text:'Date',value:'date',width:'15%'},
                                 {text:'Spirit',value:'alcoholName',width:'30%'},
                                 {text:'Description',value:'description',width:'40%'},
                                 {text:'LAA',value:'volume',width:'15%',align:'right'}]"
                      @click:row="(e,info) => viewTransaction(info.item)">
          <template v-slot:item.date="{value}">{{value | formatDate}}</template>
          <template v-slot:item.description="{item}">{{item.description}}<div class="text-caption">{{item.comments}}</div></template>
          <template v-slot:item.volume="{value}">{{value*factor | number(3)}}</template>
          <template v-slot:body.append="{headers}">
            <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
              <template v-for="header of headers">
                <td class="text-right" v-if="header.value==='volume'">
                  {{volumeTotal*factor | number(3)}}
                </td>
                <td v-else/>
              </template>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {format,add, lastDayOfMonth} from 'date-fns'
import ReportsExciseFileButton from '@/views/reports/excise/ReportsExciseFileButton'
import printHtml from '@/mixins/printHtml'
import viewTransaction from '@/mixins/viewTransaction'

export default {
  name: 'ReportsExciseSpirits',
  mixins: [printHtml,viewTransaction],
  components: {ReportsExciseFileButton},
  data() {
    return {
      dateMenu: false,
      month: '',
      license: '',
      exciseSpiritsReport: {header:{},lines:[]},
      exciseRates: null,
      showExciseRates: false,
      showDetails: false,
      title: '',
      excise: null,
      spiritsActivity: null,
      exciseTypes: [{excise:'SpiritsAdditionSpiritsProduced',title:'Spirits produced'},
                    {excise:'SpiritsAdditionReceivedFromLicensees',title:'Received from other spirits licensees and licensed users'},
                    {excise:'SpiritsAdditionImported',title:'Imported bulk spirits'},
                    {excise:'SpiritsAdditionPackagedSpiritsReturnedToBulk',title:'Packaged spirits returned to bulk spirits inventory'},
                    {excise:'SpiritsReductionRemovedToSpiritsLicensee',title:'Removed for delivery to Spirits licensees'},
                    {excise:'SpiritsReductionRemovedToLicensedUsersDomestic',title:'Removed for delivery to licensed users domestic spirits'},
                    {excise:'SpiritsReductionRemovedToLicensedUsersImported',title:'Removed for delivery to licensed users imported spirits'},
                    {excise:'SpiritsReductionDenaturedSpiritsFuelDA2F',title:'To produce denatured alcohol (DA) Fuel grades DA-2F'},
                    {excise:'SpiritsReductionDenaturedSpiritsFuelDA2G',title:'To produce denatured alcohol (DA) Fuel grades DA-2G'},
                    {excise:'SpiritsReductionDenaturedSpiritsOther',title:'To produce denatured alcohol (DA) Other grades'},
                    {excise:'SpiritsReductionSpeciallyDenaturedSpirits',title:'To produce specially denatured alcohol (SDA)'},
                    {excise:'SpiritsReductionExported',title:'Exported bulk Spirits'},
                    {excise:'SpiritsReductionToPackagingNonDutyPaidGT7',title:'Removed to packaging activities Packaged: non-duty-paid more than 7% of absolute ethyl alcohol by volume'},
                    {excise:'SpiritsReductionToPackagingNonDutyPaidLE7',title:'Removed to packaging activities Packaged: non-duty-paid not more than 7% of absolute ethyl alcohol by volume'},
                    {excise:'SpiritsReductionToPackagingNonDutyPaidMarkedSpecialContainers',title:'Removed to packaging activities Packaged: non-duty-paid Packaged in marked special containers'},
                    {excise:'SpiritsReductionToPackagingDutyPaid',title:'Removed to packaging activities Packaged: duty-paid'},
                    {excise:'SpiritsReductionBulkSpiritsReturnedToSpiritProduction',title:'Bulk spirits returned to production'},
                    {excise:'SpiritsReductionOtherNonDutyPaid',title:'Removed for other purposes Non-duty-paid'},
                    {excise:'SpiritsReductionOtherDutyPaid',title:'Removed for other purposes Duty-paid'},
                    {excise:'SpiritsInventoryAdjustment',title:'Inventory adjustments'}]
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    licenses() {
      return [...new Set(this.$store.getters.sites(true, {B266:true}).map(site => site.spiritsLicense))];
    },
    activityReport() {
      return this.spiritsActivity?.filter(activity => activity.excise === this.excise)?? [];
    },
    volumeTotal() {
      return this.activityReport.reduce((total, activity) => total + activity.volume, 0);
    },
    factor() {
      return this.excise.startsWith('SpiritsReduction') ? -1 : 1;
    }
  },
  async created() {
    this.$emit('name', 'Excise Duty Return - Spirits Licensee')
    this.month = this.$route.query.month ?? format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.license = this.licenses[0];
    this.refresh();
  },
  methods: {
    rates() {
      if (!this.exciseRates)
        this.exciseRates = () => import('@/views/reports/excise/ReportsExciseRates');
      this.showExciseRates = true;
    },
    cents(num) {
      let cents = Math.round(num % 1 * 100);
      return cents < 10 ? '0'+cents : cents;
    },
    laa(excise) {
      const entry = this.exciseSpiritsReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.laa : 0, 3);
    },
    async refresh() {
      const results = await this.$apiCall(`query ReportsExciseSpirits($license:String!,$date:Date!) {
                                            exciseSpiritsReport(license:$license,date:$date) {
                                              line4LAA,line4Excise,line5LAA,line5Excise,line6LAA,line6Excise,excisePayable,
                                              openingInventory,totalAdditions,totalReductions,closingInventory,lines{excise,laa},
                                              header {businessName,mailingAddress,city,province,postalCode,
                                                      accountNumber,accountNumberSuffix,
                                                      periodFrom,periodTo,dueDate}
                                            }
                                          }`,
                                          {license:this.license,date:this.month+'-01'});
      if (!results.error)
        this.exciseSpiritsReport = results.data.exciseSpiritsReport;
      this.spiritsActivity = null;
    },
    async details(excise) {
      if (!this.spiritsActivity) {
        let to = format(lastDayOfMonth(add(new Date(this.month+'-01'),{days:1})), 'yyyy-MM-dd');
        const results = await this.$apiCall(`query ReportsExciseSpirits($license:String!,$date:Date!,$to:Date!) {
                                                spiritsActivity(from:$date,to:$to,userLicense:false,license:$license) {
                                                  date,description,volume,alcoholName,excise,comments,refType,refId
                                                }
                                              }`,
                                            {license:this.license,date:this.month+'-01',to});
        if (!results.error)
          this.spiritsActivity = results.data.spiritsActivity;
      }
      this.excise = excise;
      this.title = this.exciseTypes.find(exciseType => exciseType.excise === excise).title;
      this.showDetails = true;
    },

    report(print) {
      const lines = [
                      `<style>
                        @page {size:portrait}
                        .excise-report {font-family: Roboto, sans-serif; font-size:12px;width:100%;border-collapse:collapse}
                        .excise-report .title {font-weight:700;font-size:18px;text-align:center}
                        .excise-report .sub-title {text-align:center}
                        .excise-report tbody tr {
                          height:30px;
                          padding:8px;
                          vertical-align:middle;
                        }
                        .excise-report .headerRow td {
                          text-align:center;
                          border-left:1px solid #000;
                          border-bottom-width:2px;
                        }
                        .excise-report .topRow td {
                          border:1px solid #000;
                          padding:8px;
                        }
                        .excise-report .topRow td:nth-child(1) {
                          width:400px;
                          text-align:left;
                        }
                        .excise-report .topRow td:nth-child(2) {
                          text-align:right;
                          width:100px;
                        }
                        .excise-report .topRow td:nth-child(3) {
                          text-align:center;
                          font-weight:bold;
                          width:5px;
                        }
                        .excise-report .topRow td:nth-child(4) {
                          text-align:right;
                          width:100px;
                        }
                        .excise-report .topRow td:nth-child(5) {
                          text-align:center;
                          width:10px;
                        }
                        .excise-report .topRow td:nth-child(6) {
                          text-align:left;
                          font-weight:bold;
                          border:none;
                          padding-left:10px;
                        }
                        .excise-report .totalRow td {
                          padding:8px;
                        }
                        .excise-report .totalRow td:nth-child(1) {
                          text-align:right;
                          font-weight:bold;
                        }
                        .excise-report .totalRow td:nth-child(2) {
                          text-align:right;
                          width:100px;
                          border:1px solid #000;
                        }
                        .excise-report .totalRow td:nth-child(3) {
                          text-align:center;
                          width:10px;
                          border:1px solid #000;
                        }
                        .excise-report .totalRow td:nth-child(4) {
                          text-align:left;
                          font-weight:bold;
                          width:10px;
                          padding-left:10px;
                        }
                        .excise-report .spacerRow {
                          height:10px;
                        }
                        .excise-report tbody tr:first-child td:nth-child(1) {
                          width:300px;
                        }
                        .excise-report tbody tr:first-child td:nth-child(2) {
                          width:300px;
                        }
                        .excise-report tbody tr:first-child td:nth-child(3) {
                          width:600px;
                        }
                        .excise-report tbody tr:first-child td:nth-child(4) {
                          width:500px;
                        }
                        .excise-report-LAA {
                          text-align:right;
                          padding-right:8px;
                          border:1px solid #666;
                          cursor: pointer
                        }
                        .legend {
                          font-weight:bold;
                          padding-left:5px;
                        }
                        .page-break {
                          page-break-before: always;
                        }
                        .page-line {
                          border-top:thin solid #ccc;
                          margin-top: 50px;
                          margin-bottom: 50px;
                        }
                      </style>`,
                    `<table class="excise-report">
                      <thead>
                        <tr>
                          <th colspan="8">
                            <div class="title">Excise Duty Return - Spirits Licensee</div>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="8">
                            <div class="sub-title">
                              Account number ${this.exciseSpiritsReport.header.accountNumber||''} RD ${this.exciseSpiritsReport.header.accountNumberSuffix}
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="8">
                            <div class="sub-title">
                              ${this.exciseSpiritsReport.header.periodFrom} to ${this.exciseSpiritsReport.header.periodTo}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="5" style="border-bottom:1px solid #000"/></tr>
                        <tr class="headerRow">
                          <td>Products (according to percentage of<br/>absolute ethyl alcohol by volume)</td>
                          <td>Quantity (litres of absolute<br/>ethyl alcohol/litres)</td>
                          <td>Code</td>
                          <td colspan="2">Duty payable</td>
                          <td colspan="3"/>
                        </tr>
                        <tr class="topRow">
                          <td>Spirits containing more than 7%</td>
                          <td>${this.$number(this.exciseSpiritsReport.line4LAA,3)}</td>
                          <td>49540</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.line4Excise),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.line4Excise)}</td>
                          <td colspan="3">4</td>
                        </tr>
                        <tr class="topRow">
                          <td>Spirits containing not more than 7%</td>
                          <td>${this.$number(this.exciseSpiritsReport.line5LAA,3)}</td>
                          <td>49542</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.line5Excise),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.line5Excise)}</td>
                          <td colspan="3">5</td>
                        </tr>
                        <tr class="topRow">
                          <td>Imported spirits delivered to licensed users</td>
                          <td>${this.$number(this.exciseSpiritsReport.line6LAA,3)}</td>
                          <td>49571</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.line6Excise),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.line6Excise)}</td>
                          <td colspan="2">6</td>
                        </tr>
                        <tr class="totalRow">
                          <td colspan="5">Total (4 to 6) ►</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.excisePayable),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.excisePayable)}</td>
                          <td>7</td>
                        </tr>
                        <tr class="spacerRow"><td colspan="8"/>
                        <tr class="totalRow">
                          <td colspan="5">Refunds (B256 attached)</td>
                          <td>0</td>
                          <td>00</td>
                          <td>8</td>
                        </tr>
                        <tr class="spacerRow"><td colspan="8"/>
                        <tr class="totalRow">
                          <td colspan="5">Net payable (7 minus 8)</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.excisePayable),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.excisePayable)}</td>
                          <td>9</td>
                        </tr>
                        <tr class="spacerRow"><td colspan="8"/>
                        <tr class="totalRow">
                          <td colspan="5">Amount due</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.excisePayable),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.excisePayable)}</td>
                          <td>10</td>
                        </tr>
                        <tr class="spacerRow"><td colspan="8"/>
                        <tr class="totalRow">
                          <td colspan="5">Payment / Credit due</td>
                          <td>${this.$number(Math.trunc(this.exciseSpiritsReport.excisePayable),0)}</td>
                          <td>${this.cents(this.exciseSpiritsReport.excisePayable)}</td>
                          <td>11</td>
                        </tr>
                      </tbody>
                    </table>`,
                    `<div class="${print?'page-break':'page-line'}"></div>`,
                    `<table class="excise-report">
                      <thead>
                        <tr>
                          <th colspan="5">
                            <div class="title">Excise Duty Return - Spirits Licensee</div>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="5">
                            <div class="sub-title">
                              Account number ${this.exciseSpiritsReport.header.accountNumber||''} RD ${this.exciseSpiritsReport.header.accountNumberSuffix}
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="5">
                            <div class="sub-title">
                              ${this.exciseSpiritsReport.header.periodFrom} to ${this.exciseSpiritsReport.header.periodTo}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="5"/>
                        </tr>
                        <tr>
                          <td colspan="3"/>
                          <td style="border:1px solid #000; text-align:center">Litres absolute ethyl alcohol</td>
                          <td/>
                        </tr>
                        <tr>
                          <td colspan="2"/>
                          <td style="font-weight:bold; text-align:right; padding-right:8px">Opening inventory ►</td>
                          <td style="border:2px solid #000; text-align:right; padding-right:8px">${this.$number(this.exciseSpiritsReport.openingInventory,3)}</td>
                          <td class="legend">A)</td>
                        </tr>
                        <tr>
                          <td colspan="4" style="border-bottom:1px solid #666; font-weight:bold">Additions to bulk spirits inventory</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Spirits produced</td>
                          <td class="excise-report-LAA" id="SpiritsAdditionSpiritsProduced">${this.laa('SpiritsAdditionSpiritsProduced')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Received from other spirits licensees and licensed users</td>
                          <td class="excise-report-LAA" id="SpiritsAdditionReceivedFromLicensees">${this.laa('SpiritsAdditionReceivedFromLicensees')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Imported bulk spirits</td>
                          <td class="excise-report-LAA" id="SpiritsAdditionImported">${this.laa('SpiritsAdditionImported')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Packaged spirits returned to bulk spirits inventory</td>
                          <td class="excise-report-LAA" id="SpiritsAdditionPackagedSpiritsReturnedToBulk">${this.laa('SpiritsAdditionPackagedSpiritsReturnedToBulk')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align:right; font-weight:bold; padding-right:8px">Total additions ►</td>
                          <td style="border:2px solid #000; text-align:right; padding-right:8px">${this.$number(this.exciseSpiritsReport.totalAdditions,3)}</td>
                          <td class="legend">B)</td>
                        </tr>
                        <tr>
                          <td colspan="4" style="border-bottom:1px solid #666; font-weight:bold">Reductions to bulk spirits inventory</td>
                        </tr>
                        <tr>
                          <td rowspan="3" style="border:1px solid #666; padding-left:8px">Removed for delivery to</td>
                          <td colspan="2" style="border:1px solid #666; padding-left:8px">Spirits licensees</td>
                          <td class="excise-report-LAA" id="SpiritsReductionRemovedToSpiritsLicensee">${this.laa('SpiritsReductionRemovedToSpiritsLicensee')}</td>
                        </tr>
                        <tr>
                          <td rowspan="2" style="border:1px solid #666; padding-left:8px">licensed users</td>
                          <td style="border:1px solid #666; padding-left:8px">domestic spirits</td>
                          <td class="excise-report-LAA" id="SpiritsReductionRemovedToLicensedUsersDomestic">${this.laa('SpiritsReductionRemovedToLicensedUsersDomestic')}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #666; padding-left:8px">imported spirits</td>
                          <td class="excise-report-LAA" id="SpiritsReductionRemovedToLicensedUsersImported">${this.laa('SpiritsReductionRemovedToLicensedUsersImported')}</td>
                        </tr>
                        <tr>
                          <td rowspan="3" style="border:1px solid #666; padding-left:8px">To produce denatured alcohol (DA)</td>
                          <td rowspan="2" style="border:1px solid #666; padding-left:8px">Fuel grades</td>
                          <td style="border:1px solid #666; padding-left:8px">DA-2F</td>
                          <td class="excise-report-LAA" id="SpiritsReductionDenaturedSpiritsFuelDA2F">${this.laa('SpiritsReductionDenaturedSpiritsFuelDA2F')}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #666; padding-left:8px">DA-2G</td>
                          <td class="excise-report-LAA" id="SpiritsReductionDenaturedSpiritsFuelDA2G">${this.laa('SpiritsReductionDenaturedSpiritsFuelDA2G')}</td>
                        </tr>
                        <tr>
                          <td colspan="2" style="border:1px solid #666; padding-left:8px">Other grades</td>
                          <td class="excise-report-LAA" id="SpiritsReductionDenaturedSpiritsOther">${this.laa('SpiritsReductionDenaturedSpiritsOther')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">To produce specially denatured alcohol (SDA)</td>
                          <td class="excise-report-LAA" id="SpiritsReductionSpeciallyDenaturedSpirits">${this.laa('SpiritsReductionSpeciallyDenaturedSpirits')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Exported bulk Spirits</td>
                          <td class="excise-report-LAA" id="SpiritsReductionExported">${this.laa('SpiritsReductionExported')}</td>
                        </tr>
                        <tr>
                          <td rowspan="4" style="border:1px solid #666; padding-left:8px">Removed to packaging activities</td>
                          <td rowspan="3" style="border:1px solid #666; padding-left:8px">Packaged: non-duty-paid</td>
                          <td style="border:1px solid #666; padding-left:8px">Containing more than 7% of absolute ethyl alcohol by volume</td>
                          <td class="excise-report-LAA" id="SpiritsReductionToPackagingNonDutyPaidGT7">${this.laa('SpiritsReductionToPackagingNonDutyPaidGT7')}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #666; padding-left:8px">Containing not more than 7% of absolute ethyl alcohol by volume</td>
                          <td class="excise-report-LAA" id="SpiritsReductionToPackagingNonDutyPaidLE7">${this.laa('SpiritsReductionToPackagingNonDutyPaidLE7')}</td>
                        </tr>
                        <tr>
                          <td style="border:1px solid #666; padding-left:8px">Packaged in marked special containers</td>
                          <td class="excise-report-LAA" id="SpiritsReductionToPackagingNonDutyPaidMarkedSpecialContainers">${this.laa('SpiritsReductionToPackagingNonDutyPaidMarkedSpecialContainers')}</td>
                        </tr>
                        <tr>
                          <td colspan="2" style="border:1px solid #666; padding-left:8px">Packaged: duty-paid</td>
                          <td class="excise-report-LAA" id="SpiritsReductionToPackagingDutyPaid">${this.laa('SpiritsReductionToPackagingDutyPaid')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="border:1px solid #666; padding-left:8px">Bulk spirits returned to production</td>
                          <td class="excise-report-LAA" id="SpiritsReductionBulkSpiritsReturnedToSpiritProduction">${this.laa('SpiritsReductionBulkSpiritsReturnedToSpiritProduction')}</td>
                        </tr>
                        <tr>
                          <td rowspan="2" style="border:1px solid #666; padding-left:8px">Removed for other purposes</td>
                          <td colspan="2" style="border:1px solid #666; padding-left:8px">Non-duty-paid (specify)</td>
                          <td class="excise-report-LAA" id="SpiritsReductionOtherNonDutyPaid">${this.laa('SpiritsReductionOtherNonDutyPaid')}</td>
                        </tr>
                        <tr>
                          <td colspan="2" style="border:1px solid #666; padding-left:8px">Duty-paid (specify)</td>
                          <td class="excise-report-LAA" id="SpiritsReductionOtherDutyPaid">${this.laa('SpiritsReductionOtherDutyPaid')}</td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align:right; font-weight:bold; padding-right:8px">Total reductions ►</td>
                          <td style="border:2px solid #000; text-align:right; padding-right:8px">${this.$number(this.exciseSpiritsReport.totalReductions,3)}</td>
                          <td class="legend">C)</td>
                        </tr>
                        <tr style="height:20px">
                          <td colspan="4"></td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align:right; font-weight:bold; padding-right:8px">Inventory adjustments (+ or -) ►</td>
                          <td style="border:2px solid #000 !important" class="excise-report-LAA" id="SpiritsInventoryAdjustment">${this.laa('SpiritsInventoryAdjustment')}</td>
                          <td class="legend">D)</td>
                        </tr>
                        <tr style="height:20px">
                          <td colspan="4"></td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align:right; font-weight:bold; padding-right:8px">Closing inventory (A+B) - C ± D ►</td>
                          <td style="border:2px solid #000; text-align:right; padding-right:8px">${this.$number(this.exciseSpiritsReport.closingInventory,3)}</td>
                          <td class="legend">E)</td>
                        </tr>
                      </tbody>
                    </table>`
      ];

      if (!print)
        this.$nextTick( () =>
          this.exciseTypes.forEach(exciseType =>
            document.getElementById(exciseType.excise).addEventListener("click", () => this.details(exciseType.excise))
          )
        )

      return lines.join('');
    }
  }
}
</script>